import A from "./citiesContentA";
import B from "./citiesContentB";

export const CITY_CONTENT = { ...A, ...B };

export const hoodSlug = (name) =>
  name.toLowerCase().replace(/['’.]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const getNeighborhoods = (citySlug) =>
  (CITY_CONTENT[citySlug]?.neighborhoods || []).map(([name, note]) => ({ name, note, slug: hoodSlug(name) }));

export const findNeighborhood = (citySlug, hSlug) =>
  getNeighborhoods(citySlug).find((n) => n.slug === hSlug);
